import { AccessoryStatus } from './accessory-status';
import {Accessory} from "./accessory";

export class AccessoryAmount {
  constructor(public id?: number, public quantity?: number, public accessoryStatus?: AccessoryStatus, public accessory?: Accessory) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/accessory-amount.ts